import { MeetCourseType } from "types/code-generator";

export function getMeetCourse(course: MeetCourseType) {
  switch (course) {
    case MeetCourseType.Yards:
      return "Y";
    case MeetCourseType.LCM:
      return "L";
    case MeetCourseType.SCM:
      return "S";
    default:
      return "Y";
  }
}
